import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CtaButton from 'components/essentials/Cta/CtaButton';
import isClient from 'commons/isClient';
import SanitizedHtml from 'components/consumer/SanitizedHtml';
const SHOW_MORE_LIMIT = 500;
const COLLAPSED_CLASSES = 'max-h-[192px] md:max-h-[120px] overflow-hidden';
class ExpandableTextContainer extends React.Component {
  state = {
    content: this.props.content,
    showMoreEnabled: this.props.content?.length > SHOW_MORE_LIMIT,
    showMoreExpanded: false
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.content && nextProps.content !== prevState.content) {
      return {
        content: nextProps.content,
        showMoreEnabled: nextProps.content?.length > SHOW_MORE_LIMIT,
        showMoreExpanded: false
      };
    }
    return null;
  }
  toggleShowMore = () => {
    this.setState(prevState => ({
      showMoreExpanded: !prevState.showMoreExpanded
    }));
  };
  render() {
    const {
      content,
      showMoreEnabled,
      showMoreExpanded
    } = this.state;
    const isCollapsed = showMoreEnabled && !showMoreExpanded;
    return <div className="[&_a]:text-brand [&_button]:[background:none] [&_button]:border-0">
        <div className={classNames(isCollapsed && COLLAPSED_CLASSES)}>
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
          <div label="expandable-text-container-button" onClick={evt => {
          // https://stitchindustries.atlassian.net/browse/CON-3001
          if (isClient() && evt.target.tagName.toLowerCase() === 'a') {
            window.sessionStorage.removeItem('scrollPosition.category');
          }
        }}>
            <SanitizedHtml html={content} />
          </div>
        </div>

        {showMoreEnabled && <CtaButton styling="link" hasArrow={false} color="brand" onClick={this.toggleShowMore} className="bg-none border-0">
            {showMoreExpanded ? 'Read less' : 'Read more'}
          </CtaButton>}
      </div>;
  }
}
ExpandableTextContainer.propTypes = {
  content: PropTypes.string.isRequired
};
export default ExpandableTextContainer;